import React from 'react'; // eslint-disable-line

const AppWrapper = (props) => {
    return (
        <div className="app-intro__intro">
            <h1 className="app-intro">{props.children}</h1>
        </div>
    );
};
export default AppWrapper;
